/* eslint-disable @typescript-eslint/no-explicit-any */
import { Reducer } from 'redux';
import questionSlice, { ONBOARDING_QUESTION_KEY_IN_STORE } from './slice';
import { onboardingQuestionsSaga } from './sagas';

export class QuestionModule {
	getRootKeyInStore(): string {
		return ONBOARDING_QUESTION_KEY_IN_STORE;
	}

	getReducers(): Reducer {
		return questionSlice.reducer;
	}

	getSagas(): () => Generator<any, void, any> {
		return onboardingQuestionsSaga;
	}
}

export const moduleInstance = new QuestionModule();
